import SvgIcon from '@Web/Src/Components/SvgIcon';
import LinkSection from '@Web/Src/UI/LinkSection';
import { router } from '@inertiajs/react';

const Card = ({ data, className, sprite, iconSize, titleSize = 'text-xl' }) => {
    const { icon, title, text, link, linkText, titleLink, newTab, code = null, slug } = data;

    const handleSubmit = () => {
        if (newTab) {
            window.open(link, '_blank', 'noopener, noreferrer');
        } else if (link) {
            router.visit(route(link, { code, slug }));
        }
    };

    const handleLink = () => {
        window.open(titleLink, '_blank', 'noopener, noreferrer');
    };

    return (
        <div
            className={`text-dark small:min-h-[auto] small:max-w-none w-full max-w-64 rounded-3xl p-6 shadow-[0px_0px_4px_0px_rgba(0,28,55,0.12),0px_8px_16px_0px_rgba(39,120,234,0.12)] ${className} `}
        >
            {icon && (
                <div className={'text-blue'}>
                    <SvgIcon className={iconSize} collectionName={sprite} iconId={icon} />
                </div>
            )}
            {titleLink ? (
                <h3
                    onClick={handleLink}
                    className={`mt-4 cursor-pointer font-bold underline ${titleSize}`}
                >
                    {title}
                </h3>
            ) : (
                <h3 className={`mt-4 font-bold ${titleSize}`}>{title}</h3>
            )}
            <p className={'mt-4 leading-5'}>{text}</p>
            {(link || newTab !== undefined) && (
                <LinkSection
                    className={`!mt-4 ${newTab === false ? '!cursor-default' : ''}`}
                    position={'left'}
                    handleClick={handleSubmit}
                    link={linkText}
                    url={link}
                />
            )}
        </div>
    );
};

export default Card;
